import axios from '@/utilities/api/axios';

export const state = initialState();

export const actions = {
  getRoles: async ({ commit }) => {
    try {
      const res = await axios.get(`/roles`);
      commit('mutateRoles', res.data);
    } catch (err) {
      console.error(err);
      return;
    }
  }
};

export const mutations = {
  mutateRoles: (state, payload) => {
    state.roles = payload;
  }
};

export const getters = {};

function initialState() {
  return {
    roles: []
  };
}
